import { render, staticRenderFns } from "./IndividualJdModal.vue?vue&type=template&id=a87ff096&scoped=true&"
import script from "./IndividualJdModal.vue?vue&type=script&lang=js&"
export * from "./IndividualJdModal.vue?vue&type=script&lang=js&"
import style0 from "./IndividualJdModal.vue?vue&type=style&index=0&id=a87ff096&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87ff096",
  null
  
)

export default component.exports